import { getAdminStats } from '../../api/admin'
import { ErrorBox } from '../ui/Card'
import { useFetch } from '../../hooks/useFetch'
import { StatCard } from './StatCard'

export function PlatformOverviewWidget() {
  const { data: stats, error, loading } = useFetch(() => getAdminStats(), [])

  return (
    <div>
      <div className="text-xs font-bold text-text-2 uppercase tracking-[0.06em] mb-3">
        Platform overview
      </div>
      {error && <ErrorBox className="mb-4">Could not load statistics: {error}</ErrorBox>}
      <div className="grid grid-cols-[repeat(auto-fill,minmax(160px,1fr))] gap-4">
        <StatCard label="Total users" value={loading ? undefined : stats?.total_users} />
        <StatCard label="Organisations" value={loading ? undefined : stats?.total_organizations} />
        <StatCard label="Practices" value={loading ? undefined : stats?.total_practices} />
        <StatCard label="Clients" value={loading ? undefined : stats?.total_clients} />
        <StatCard label="Patients" value={loading ? undefined : stats?.total_patients} />
        <StatCard
          label="New signups"
          value={loading ? undefined : stats?.users_registered_recently}
          sub="Last 7 days"
        />
      </div>
    </div>
  )
}
